import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import theme from '../../theme'
import { useTheme } from '@mui/material'

// material components
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import {Box} from '@mui/material'

// application components
import CloseIcon from '@mui/icons-material/Close'
import SaveIcon from '@mui/icons-material/Save'
import ArrowIcon from '@mui/icons-material/ArrowBack'

const styles = {
    drawerPaper: {
        width: 80,
        // position: 'relative',
        whiteSpace: 'nowrap',
        //backgroundColor:"red",
        height: '100%',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down('sm')]: {
             width: 405,
            //backgroundColor:"red",

        },
        [theme.breakpoints.down('xs')]: {
            minWidth: 120,
            width: '80%',
            //maxWidth: 80,
            position: 'absolute',
            //backgroundColor:"green",
        },
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        backgroundColor:theme.palette.primary.main,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    drawerHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '4px 4px 4px 27px',
        boxSizing: 'border-box',
        position: 'absolute',
        width: '100%',
        height: 64,
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 16,
        },
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 16,
        },
    },
    closeIcon: {
        color: theme.palette.primary.main,
    },
    changed: {
        backgroundColor: theme.palette.primary.dark,
        display:'flex',
        flexDirection:'row',
        justifyContent:"space-between",
        alignItems:"center",
        padding: '4px 4px 4px 27px',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing.unit * 2,
        },
    },
    changedText: {
        color: 'white',
    },
    blank: {
        
    },
    deletionBackground: {
        backgroundColor: theme.palette.error.dark,
        padding: '4px 4px 4px 27px',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing.unit * 2,
        },
    },
    deletionText: {
        color: '#fff',
        fill: 'fff',
    },
    rangeErrors: {
        // color: theme.palette.error.contrastText,
        backgroundColor: theme.palette.error.main,
    },
}

/**
 * Stateless Sidebar Component.
 * @param action   (values => factoryReset, userDelete, userPwdChange, userProfileDownload, timerSettings, newDevice)
 * @param title
 * @param changed
 * @param open
 * @param classes
 * @param children
 * @param closed
 * @param handleSidebarChange
 * @returns {*}
 */
const sidebar = ({ action, title, changed, open, classes, children, closed, error, handleSidebarChange, tokenIssued }) => {
const theme = useTheme();
    return(
        <Drawer
        variant="persistent"
        open={open}
        anchor="right"
        //classes={{ paper: classNames(styles.drawerPaper, !open && styles.drawerPaperClose) }}
        style={!open?styles.drawerPaperClose:styles.drawerPaper}
        SlideProps={{ unmountOnExit: true }}
    >
        
         <Box style={(changed || (('userPwdChange' === action) || ('newDevice' === action)))?styles.changed:(error||('userDelete' === action) || ('factoryReset' === action))?styles.deletionBackground:styles.drawerHeader} sx={{display:"flex", flexDirection:"row", justifyContent:"space-between", alignItems:"center", padding:10}}>
           {/*  style={classNames(styles.drawerHeader, (changed || ('userPwdChange' === action) || ('newDevice' === action)) && styles.changed, (('userDelete' === action) || ('factoryReset' === action) || error) && styles.deletionBackground)}> */}
           
            {(((changed && action !== 'newDevice') || ('factoryReset' === action)) && (tokenIssued !== true))
            && (
                <IconButton onClick={() => handleSidebarChange()}>
                    <SaveIcon style={(changed?styles.changedText:('factoryReset' === action)?styles.deletionText:styles.blank)}/>
                        {/* style={classNames(changed && styles.changedText, ('factoryReset' === action) && styles.deletionText)}/> */}
                </IconButton>
            )}
            <Typography style={((changed || ('userPwdChange' === action))?styles.changedText:(('userDelete' === action) || ('factoryReset' === action) || error)?styles.deletionText:styles.blank)}
                /* style={classNames((changed || ('userPwdChange' === action)) && styles.changedText, (('userDelete' === action) || ('factoryReset' === action) || error) && styles.deletionText)} */
                variant="h5" >
                {title}
            </Typography>
            <IconButton onClick={() => closed()}>
                {('timerSettings' === action)
                    ? (<ArrowIcon style={{...styles.deletionText, fill: theme.palette.custom.hoverItem}}/>)
                    : (<CloseIcon style={(styles.closeIcon, (changed || ('userPwdChange' === action))?styles.changedText:(('userDelete' === action) || ('factoryReset' === action) || error)?styles.deletionText:styles.blank)}/>)
                        /* style={classNames(styles.closeIcon, (changed || ('userPwdChange' === action)) && styles.changedText, (('userDelete' === action) || ('factoryReset' === action) || error) && styles.deletionText)}/>) */
                }
            </IconButton>
        </Box> 
        <div style={{ position: 'relative', top: 50, marginTop: 15 }}>
            {children}
        </div>
        </Drawer>
    )
    
}

sidebar.propTypes = {
    title: PropTypes.string.isRequired,
    closed: PropTypes.func.isRequired,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    children: PropTypes.node.isRequired,
    deletion: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]),
    changed: PropTypes.bool,
    open: PropTypes.bool,
    factoryReset: PropTypes.bool,
    handleDeleteUser: PropTypes.func,

    // handleSidebarChange: PropTypes.func,
    handleSidebarChange: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.func,
    ]),

    handleNewActiveDevice: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.func,
    ]),

    action: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]),

    error: PropTypes.bool,
}

sidebar.defaultProps = {
    changed: false,
    open: false,
    deletion: false,
    factoryReset: false,
    error: false,
}

export default sidebar
